var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#FDF2FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2527 15.5833L15.5954 19.2407C15.0447 19.7913 15.0447 20.6847 15.5954 21.2353V21.2353C16.146 21.786 17.0394 21.786 17.59 21.2353L22.4114 16.414C23.4214 15.404 23.4214 13.7667 22.4114 12.7567V12.7567C21.4014 11.7467 19.764 11.7467 18.754 12.7567L13.9327 17.578C12.4634 19.0473 12.4634 21.4287 13.9327 22.898V22.898C15.402 24.3673 17.7834 24.3673 19.2527 22.898L22.1787 19.972",
    stroke: "#DD2590",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05887 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05887 27.9411 0 18 0V4ZM18 0C8.05887 0 0 8.05887 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "#FDF2FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentGlow);
export default __webpack_public_path__ + "static/media/attachment-glow.667d7b423523a8ab0f575335346245a0.svg";
export { ForwardRef as ReactComponent };